module.exports = __webpack_public_path__ + "media/images/landing__teaser__scoring--mobile-4fe6a548c51095d7ee4380c57ae0c55a.png";